<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>{{ editMode ? 'Fund Information'
      : !isCertificated ? fund.name : fund.organization.name}}</mat-card-title>
      <mat-card-subtitle style="margin-bottom: 8px;">@if (!editMode && !isCertificated && permissions?._edit) {
        <button mat-raised-button class="edit-button" (click)="toggleEdit()">EDIT</button>
      }</mat-card-subtitle>
      <mat-card-subtitle style="margin-bottom: 8px;">@if (editMode && !isCertificated && permissions?._edit) {
        <button mat-raised-button class="save-button" (click)="save()">SAVE</button>
        }@if (editMode && !isCertificated && permissions?._edit) {
        <button mat-raised-button class="edit-button" (click)="toggleEdit()">Cancel</button>
      }</mat-card-subtitle>
      @if (!editMode) {
        <mat-card-subtitle>{{ !isCertificated ? fund.fundType.name : 'Certificated Outlet'}}</mat-card-subtitle>
      }
      <!--      <button mat-raised-button class="edit-button" *ngIf="!editMode && !isCertificated && permissions?._edit" (click)="toggleEdit()">EDIT</button>-->
      <!--      <button mat-raised-button class="save-button" *ngIf="editMode && !isCertificated && permissions?._edit" (click)="save()">SAVE</button>-->
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content>
    @if (!editMode && !isCertificated) {
      <div class="col-md-12">
        <div class="row align-top">
          <div class="col-md-4">
            <div class="row">
              <span>{{getLegalName(fund)}}</span>
              @if (getManagingMember(fund)!==null) {
                <span><strong>Managing Member:</strong> {{getManagingMember(fund)}}</span>
              }
              <span><strong>Status:</strong> {{getFundStatus(fund)}}</span>
              <span><strong>Commitments Required:</strong> {{fund.commitments_required !== null ? (fund.commitments_required ? 'Yes':'No') : '\u2014'}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              @if (fund.ltmodels?.length > -1) {
                <span><strong>Last UTModel Export:</strong> {{($safeNavigationMigration(fund.ltmodels[0]?.created) | date: "M-d-yy h:mm a z") ?? '\u2014'}}</span>
              }
              @if (fund.ein!==null) {
                <span><strong>EIN:</strong> {{fund.ein}}</span>
              }
              @if (fund.ic_code!==null) {
                <span><strong>IC Code:</strong> {{fund.ic_code}}</span>
              }
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <span><strong>Total Committed Equity:</strong> {{fund.invested_equity | currency: 'USD': 'symbol': '1.0-0'}}</span>
              <span><strong>Total Specified Equity:</strong> {{fund.specified_equity | currency: 'USD': 'symbol': '1.0-0'}}</span>
              <span><strong>Closing Date:</strong> {{fund.close_date | date: 'MM/dd/yyyy'}}</span>
            </div>
          </div>
        </div>
      </div>
    }
    @if (editMode && !isCertificated) {
      <div class="col-md-12">
        <form [formGroup]="infoGroup">
          <div class="row align-top gutters">
            <div class="col-md-4">
              <div class="row">
                <mat-form-field>
                  <mat-label>Name</mat-label>
                  <input matInput formControlName="name" type="text" name="name">
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field>
                  <mat-label>Legal Name</mat-label>
                  <input matInput formControlName="legal_name" type="text" name="legal_name">
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field>
                  <mat-label>Managing Member</mat-label>
                  <input matInput type="text" formControlName="mngMember" name="mngMember">
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field>
                  <mat-label>Commitments Required</mat-label>
                  <mat-select formControlName="commitments_required">
                    <mat-option [value]="null">&mdash;</mat-option>
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <mat-form-field>
                  <mat-label>Status</mat-label>
                  <mat-select formControlName="status">
                    @for (status of statuses; track status) {
                      <mat-option [value]="status.id">{{status.name}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field>
                  <mat-label>IC Code</mat-label>
                  <input matInput type="text" formControlName="ic_code" name="ic_code">
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field>
                  <mat-label>EIN</mat-label>
                  <input matInput formControlName="ein" type="text" name="ein">
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <mat-form-field>
                  <mat-label>Fund Type</mat-label>
                  <mat-select formControlName="type">
                    @for (type of types; track type) {
                      <mat-option [value]="type.id">{{type.name}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field>
                  <mat-label>Closing Date</mat-label>
                  <input matInput type="text" formControlName="closingDate" name="closingDate" [matDatepicker]="closeDatePicker">
                  <mat-datepicker-toggle matIconPrefix [for]="closeDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #closeDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="row">
                <mat-form-field>
                  <mat-label>Total Committed Equity</mat-label>
                  <mat-icon matPrefix style="color: darkgray">attach_money</mat-icon>
                  <input matInput type="number" formControlName="totalCommittedEquity" name="totalCommittedEquity">
                  <mat-hint>{{infoGroup.controls['totalCommittedEquity'].value | currency: 'USD': 'symbol': '1.0-0'}}</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
        </form>
      </div>
    }
  </mat-card-content>
</mat-card>

